import { useMemo } from 'react';

import { useTranslation } from 'react-i18next';
import * as yup from 'yup';

import { CredentialedScanningType } from '../../../types';

export const useScanCredentialFormValidationSchema = (
  credType: CredentialedScanningType,
) => {
  const { t } = useTranslation('telemetryScannerConfig:validationMessage');
  const emptyField = t('telemetryScannerConfig:validationMessage.emptyField');
  const emptyTargets = t(
    'telemetryScannerConfig:validationMessage.emptyTargets',
  );
  const invalidType = t('telemetryScannerConfig:validationMessage.invalidType');
  return useMemo(() => {
    const name = yup.string().required(emptyField);
    const targets = yup.array().min(1, emptyTargets);
    const username = yup.string().required(emptyField);
    const type = yup.string().oneOf(['up', 'usk'], invalidType);
    const sshKey = yup.string().required(emptyField);

    if (credType === CredentialedScanningType.Usk) {
      return yup
        .object()
        .shape({
          name,
          sshKey,
          targets,
          type,
          username,
        })
        .required();
    }

    return yup
      .object()
      .shape({
        name,
        targets,
        type,
        username,
      })
      .required();
  }, [credType, emptyField, emptyTargets, invalidType]);
};
